export default __webpack_public_path__ + "static/media/019-water glass.3b046cff.svg";